const prodDomains = ["www.asos.com", "www.topshop.com"];

export const isProd = () =>
  prodDomains.includes(window?.location?.hostname?.toLowerCase());
